import React from "react";
import { EventOffer } from "@gp/offer";
import { EventMatchTime } from ".";

export default function EventName({ event }: { event: EventOffer }) {
	return (
		<div className="event__details event__details--col">
			<div className="event__team">
				<div className="event__team__title">{event.name}</div>
			</div>
			<EventMatchTime event={event} />
		</div>
	);
}
